import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useFeatureVisibility } from '@/contexts/FeatureVisibilityContext';

/** Bloquea rutas S&OP V2 si la org/usuario no tiene `demand_planning` visible. */
export function DemandPlanningModuleGate({ children }: { children: ReactNode }) {
  const { isModuleVisible, loading } = useFeatureVisibility();

  if (loading) {
    return null;
  }

  if (!isModuleVisible('demand_planning', true)) {
    return <Navigate to="/supply" replace />;
  }

  return children;
}
